import { render, staticRenderFns } from "./TabelaUsuarios.vue?vue&type=template&id=190ae4ef"
import script from "./TabelaUsuarios.vue?vue&type=script&lang=js"
export * from "./TabelaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./TabelaUsuarios.vue?vue&type=style&index=0&id=190ae4ef&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports